module.exports = __webpack_public_path__ + "fonts/EBGaramond-Italic-VariableFont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/EBGaramond/EBGaramond-Italic-VariableFont.ttf
// module id = 3492
// module chunks = 0